import request from "@/utils/request";

export function getDistributeLeaflets(data) {
  return request({
    url: "/merchant/merchantTaskInfo/listByParam",
    method: "post",
    data: data
  });
}
export function getDistributeLeafletsN(data) {
  return request({
    url: "/merchant/merchantTask/pageList",
    method: "post",
    data: data
  });
}

export function getDistributeLeafletsInfo(data) {
  return request({
    url: "/merchant/merchantTaskInfo/getByTaskNo",
    method: "post",
    data: data
  });
}

export function getTaskInfo(data) {
  return request({
    url: "/merchant/merchantTask/detail",
    method: "post",
    data: data
  });
}

// 任务详情列表tab
export function taskTabList(data) {
  return request({
    url: "/merchant/merchantTaskInfo/listParam",
    method: "post",
    data: data
  });
}

// 批量结算——校验接口
export function batchClusterPayCheck() {
  return request({
    url: "/merchant/batchPay/batchClusterPayCheck",
    method: "get"
  });
}

// 批量结算
export function getDistributeLeafletsInfoLi(data) {
  return request({
    url: "/merchant/merchantTaskInfo/listByMerchantIdParam",
    method: "post",
    data: data
  });
}
// 批量操作、/取消/驳回/通过/结算
export function handleBatchV2(data) {
  return request({
    url: "/merchant/merchantTaskInfo/updateRejectBatchById/v2",
    method: "post",
    data: data
  });
}

//打款-导出
export function exportEntrustPayData(params) {
  return request({
    url: "/merchant/batchPay/exportEntrustPayData",
    method: "get",
    params,
    exportFiles: true
  });
}

export function handleBatch(data) {
  return request({
    url: "/merchant/merchantTaskInfo/updateRejectBatchById",
    method: "post",
    data: data
  });
}

export function getTaskPreTradeInfo(data) {
  return request({
    url: "/merchant/merchantTaskInfo/pre/trade",
    method: "post",
    data: data
  });
}

// 批次结算详情
export function getPaymentInfo(data) {
  return request({
    url: "/merchant/taskInfo/getByUnBatchNo",
    method: "post",
    data: data
  });
}
// 校验结果统计
export function getStatisticsInfo(data) {
  return request({
    url: "/merchant/taskInfo/getBatchInfo",
    method: "post",
    data: data
  });
}
// 批次结算金额
export function getPaymentInfoCount(data) {
  return request({
    url: "/merchant/taskInfo/listByParamCount",
    method: "post",
    data: data
  });
}

// 获取验证码
export function getCode(data) {
  return request({
    url: "/merchant/merchantTaskInfo/getVerifyCode",
    method: "get",
    params: data
  });
}

// 取消此次打款
export function cancelPayment(data) {
  return request({
    url: "/merchant/merchantTaskInfo/cancelPay",
    method: "post",
    data: data
  });
}

// 充值弹窗内容
export function selectPlatform(data) {
  return request({
    url: "/merchant/taskInfo/selectPlatform",
    method: "post",
    data: data
  });
}

// 安全发-使用网银充值
export function selectByMerchantFundsId(data) {
  return request({
    url: "/merchant/merchantFinance/selectByMerchantFundsId",
    method: "get",
    params: data
  });
}

// 支付宝充值2
export function findBydBankType(data) {
  return request({
    url: "/merchant/taskInfo/selectMerchantAccountList",
    method: "post",
    data: data
  });
}

// 打款弹窗内容
export function paymentSurePay(data) {
  return request({
    url: "/merchant/merchantTaskInfo/surePay?batchSettlementNo=" + data.batchSettlementNo,
    method: "get",
    data: data
  });
}

// 确认打款
export function checkPayment(data) {
  return request({
    url: "/merchant/merchantTaskInfo/checkPassword",
    method: "post",
    data: data
  });
}

// 获取指派人员列表
export function getAssignPersonnel(data) {
  return request({
    url: "/merchant/merchantTaskInfo/selectStaffByMerchantIdAndAgreementId",
    method: "post",
    data: data
  });
}

// 新增任务
export function addMerchantTask(data) {
  return request({
    url: "/merchant/merchantTaskInfo/insert",
    method: "post",
    data: data
  });
}
// 新增任务
export function addMerchantTaskN(data) {
  return request({
    url: "/merchant/merchantTask/add",
    method: "post",
    data: data
  });
}
// 取消任务
export function cancelMerchantTask(data) {
  return request({
    url: "/merchant/merchantTaskInfo/updateById",
    method: "post",
    data: data
  });
}

// 取消任务
export function cancelMerchantTaskN(data) {
  return request({
    url: "/merchant/merchantTask/cancelMerchantTask",
    method: "post",
    data: data
  });
}

// 获取行业和开票类目
export function getAgreementInfo(data) {
  return request({
    url: "/merchant/AgreementInfo/getAgreementInfo",
    method: "get",
    params: data
  });
}

// 获取服务商的经营范围
export function getTaxByMerchantIdAndTaxId(data) {
  return request({
    url: "/merchant/merchantTaskInfo/getTaxByMerchantIdAndTaxId",
    method: "post",
    params: data
  });
}

// 获取可指派人员
export function getTaskInfoList(data) {
  return request({
    url: "/merchant/merchantTaskInfo/selectStaffByMerchantIdAndAgreementId",
    method: "post",
    params: data
  });
}

export function updateMerchantTaskInfoById(data) {
  return request({
    url: "/merchant/merchantTask/updateMerchantTaskInfoById",
    method: "post",
    data: data
  });
}

export function setSharedmerchantTask(data) {
  return request({
    url: "/merchant/merchantTask/setSharedmerchantTask",
    method: "post",
    data: data
  });
}

export function applyAlipayChange(data) {
  return request({
    url: "/merchant/merchantFinance/applyAlipayChange",
    method: "get",
    params: data
  });
}
